// src/services/authService.ts
import { API_BASE_URL } from "../config";

export async function login(username: string, password: string) {
  const res = await fetch(`${API_BASE_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include", // falls Server Session-Cookies setzt
    body: JSON.stringify({ username, password }), // ggf. unten an Feldnamen anpassen!
  });

  // Inhalt (Text oder JSON) sicher lesen
  const ct = res.headers.get("content-type") || "";
  const body = ct.includes("application/json") ? await res.json().catch(() => ({})) : await res.text();

  if (!res.ok) {
    const message =
      (typeof body === "string" ? body : body?.message || body?.error) ||
      `Login fehlgeschlagen (HTTP ${res.status})`;
    throw new Error(message);
  }
  return body;
}
